import axios from 'axios'
import { cancelPendingLogout } from 'shared/api/logout'

import { ContactType, generateMobileBody, getContactType } from '../helpers/authHelper'

export { logout } from 'shared/api/logout'

const csrfTokenUrl = '/api/v1/auth/csrf/'
const authEmailUrl = '/api/v1/auth/email/'
const authMobileUrl = '/api/v1/auth/mobile/'
const authVerifyUrl = '/api/v1/auth/session/'
export function getCsrfTokenCookie() {
  return axios.get(csrfTokenUrl)
}

export function requestLoginToken(data: string) {
  const type = getContactType(data)
  const url = type === ContactType.Email ? authEmailUrl : authMobileUrl
  const body = type === ContactType.Email ? { email: data } : generateMobileBody(data)
  return axios.post(url, body)
}

export function verifyLoginToken(loginToken: string, userContact: string) {
  const type = getContactType(userContact)
  let body: Record<string, string> = {}
  if (type === ContactType.Email) {
    body.email = userContact
  } else {
    body = generateMobileBody(userContact)
  }
  body.token = loginToken

  // A late logout response must not clear the session cookie issued by this login.
  cancelPendingLogout()
  return axios.post(authVerifyUrl, body)
}

// New API requests used with react-query
export function verifyLoginCodeToken(loginToken: string, userContact: string) {
  const type = getContactType(userContact)
  let body: Record<string, string> = {}
  if (type === ContactType.Email) {
    body.email = userContact
  } else {
    body = generateMobileBody(userContact)
  }
  body.token = loginToken

  // A late logout response must not clear the session cookie issued by this login.
  cancelPendingLogout()
  return axios.post(authVerifyUrl, body)
}
